import { DragIndicator } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ConfirmationNumberTwoToneIcon from "@mui/icons-material/ConfirmationNumberTwoTone";
import ConnectedTvOutlinedIcon from "@mui/icons-material/ConnectedTvOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import { Tooltip } from "antd";
import React from "react";
import "./SmallCard.css";

const SmallCard = ({
  title,
  subtitle,
  panelCount,
  value,
  body,
  onClick,
  onDelete,
  column,
  ticketMeddle,
  isMobile = false,
  dragRef = null,
  // onArchive,
}) => {
  const config = true
    ? { style: "currency", currency: "BRL" }
    : { minimumFractionDigits: 2 };

  const handleDragIconClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className={column == "❌ Recusada" ? "small-card-red" : "small-card"}
      onClick={onClick}
      ref={!isMobile && dragRef ? dragRef : null}
    >
      {/* Ícone de arrastar - apenas no mobile */}
      <div
        className="drag-handle-mobile"
        onClick={handleDragIconClick}
        ref={isMobile && dragRef ? dragRef : null}
      >
        <DragIndicator
          style={{
            cursor: isMobile ? "grab" : "default",
            color: "#666",
            fontSize: "20px",
            userSelect: "none",
          }}
        />
      </div>

      <div className="small-card-menu-container">
        {/* TODO: Remover este comentário quando o backend estiver pronto */}
        {/* <Tooltip title="Arquivar">
              <div
                className="small-card-menu-item"
                onClick={(e) => {
                  e.stopPropagation();
                  onArchive();
                }}
              >
                <ArchiveIcon style={{ fontSize: "16px" }} />
              </div>
            </Tooltip> */}
        <Tooltip title="Excluir">
          <div
            className="small-card-menu-item small-card-menu-item-danger"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <CloseIcon style={{ fontSize: "16px" }} />
          </div>
        </Tooltip>
      </div>

      {/* Conteúdo do Card */}
      <div className="small-card-content">
        <div className="small-card-header">
          <div className="small-card-title">
            {title.length > 20 ? title.slice(0, 20) + "..." : title}
          </div>
          <div className="small-card-subtitle">
            {subtitle.length > 25 ? subtitle.slice(0, 25) + "..." : subtitle}
          </div>
        </div>

        <div className="small-card-body">
          <div className="small-card-body-content">{body}</div>
          <div className="small-card-value">
            <PaidOutlinedIcon
              style={{ width: "22px", paddingRight: "4px", color: "#ff9500" }}
            />
            {parseFloat(value).toLocaleString("pt-BR", config)} | {panelCount}
            <ConnectedTvOutlinedIcon
              style={{ width: "20px", paddingLeft: "4px", color: "#007aff" }}
            />
          </div>
          <div className="small-card-value">
            <ConfirmationNumberTwoToneIcon
              style={{ width: "20px", paddingLeft: "1px", color: "#007aff" }}
            />
            {ticketMeddle
              ? parseFloat(ticketMeddle).toLocaleString("pt-BR", config)
              : 0}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallCard;
